import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    padding: '2rem',
    overflowY: 'auto',
    marginTop: '1rem'
  },
  loadingCircular: {
    position: 'absolute',
    left: '55%',
    top: '50%'
  }
}));
